// frontend/src/api/admin.js

async function parseResponse(res) {
  const contentType = res.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");
  const payload = isJson ? await res.json() : await res.text();

  if (!res.ok) {
    const detail = isJson && payload ? payload.detail : null;
    // FastAPI 422s carry a list of { loc, msg } — show the messages, not the JSON.
    const validation =
      Array.isArray(detail) &&
      detail
        .map((d) => String(d?.msg || "").replace(/^Value error, /, ""))
        .filter(Boolean)
        .join("; ");
    const message =
      validation ||
      (typeof detail === "string" && detail) ||
      (detail && typeof detail === "object" && (detail.error || JSON.stringify(detail))) ||
      (typeof payload === "string" && payload) ||
      `${res.status} ${res.statusText}`;
    throw new Error(message);
  }

  return payload;
}

/**
 * POST /api/admin/organizations
 * Body: { name, host, port, database, username, password, provider, auth0 | okta }
 * Returns { id, name }
 */
export async function createOrganization(payload) {
  const res = await fetch("/api/admin/organizations", {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  return parseResponse(res);
}

/**
 * GET /api/admin/organizations/lookup?name=
 * Returns { matches: [...], unlinked_identity_providers: [...] }
 */
export async function lookupOrganization(name) {
  const params = new URLSearchParams({ name });
  const res = await fetch(`/api/admin/organizations/lookup?${params}`, {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  return parseResponse(res);
}

/**
 * POST /api/admin/organizations/delete
 * Returns { id, name, removed: { organization_identity_providers, feature_flags, cluster_connections } }
 */
export async function deleteOrganization(orgId, confirmName) {
  const res = await fetch("/api/admin/organizations/delete", {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ org_id: orgId, confirm_name: confirmName }),
  });
  return parseResponse(res);
}
